<script>
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import StrIcDegerBirim from "../StrIcDegerBirim/Index";
export default {
  mixins: [Api, Sabit],
  props: ["UstId","UpdateAltTable"],
  data() {
    return {
      Page: {
        PageNumber: "1",
        PageSize: "9999",
        PageDataSize: "1",
      },
      TableData: [],
    };
  },
  components: {
    StrIcDegerBirim,
  },
  watch:{
    UpdateAltTable(){
      if(this.UpdateAltTable == true){
        this.Get();
      }
    }
  },
  methods: {
    Get() {
      let Filter = "&Ustid=" + this.UstId + "&Seviye=2";
      this.ActionsFilterGet({ Service: "StrIcDegerTablo", Page: this.Page, Filter: Filter }).then((res) => {
        this.TableData = res.Data;
        this.Page.PageDataSize = res.TotalCount;
      });
    },
  },
};
</script>
<template>
  <div>
    <table class="table table-striped table-bordered mb-0">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col">
            {{ $t("StrIcDegerTablo.Table.SiraNo") }}
          </th>
          <th scope="col">
            {{ $t("StrIcDegerTablo.Table.TabloAdi") }}
          </th>
          <th scope="col" >
            {{ $t("StrIcDegerTablo.Table.Aktif") }}
          </th>
          <th scope="col" >
            {{ $t("StrIcDegerTablo.Table.Aciklama") }}
          </th>
          <th scope="col">
            {{ $t("StrIcDegerTablo.Table.Olgunluk1") }}
          </th>
          <th scope="col">
            {{ $t("StrIcDegerTablo.Table.Olgunluk2") }}
          </th>
          <th scope="col">
            {{ $t("StrIcDegerTablo.Table.Olgunluk3") }}
          </th>
          <th scope="col">
            {{ $t("StrIcDegerTablo.Table.Olgunluk4") }}
          </th>
          <th scope="col">
            {{ $t("StrIcDegerTablo.Table.Olgunluk5") }}
          </th>
          <th scope="col" >
            {{ $t("StrIcDegerTablo.Table.Islem") }}
          </th>
        </tr>
      </thead>
      <tbody v-for="TableDataVerileri in TableData" :key="TableDataVerileri.Id">
        <tr>
          <th scope="row" class="custom-accordion">
            <a
              class="
                          text-body
                          fw-medium
                          py-1
                          d-flex
                          align-items-center
                        "
              data-toggle="collapse"
              v-b-toggle="'CollapseAltTablo2' + TableDataVerileri.Id"
              role="button"
              aria-expanded="false"
              aria-controls="categories-collapse"
            >
              <i class="mdi mdi-chevron-up accor-down-icon ms-auto"></i>
            </a>
          </th>
          <td>{{ TableDataVerileri.Sirano }}</td>
          <td>{{ TableDataVerileri.Tabloadi }}</td>
          <td >
              <i v-if="TableDataVerileri.Aktif" class="fas fas fa-check"></i>
              <i v-if="!TableDataVerileri.Aktif" class="fas fas fa-times"></i>
          </td>
          <td>{{ TableDataVerileri.Aciklama }}</td>
          <td>{{ TableDataVerileri.Olgunluk1 }}</td>
          <td>{{ TableDataVerileri.Olgunluk2 }}</td>
          <td>{{ TableDataVerileri.Olgunluk3 }}</td>
          <td>{{ TableDataVerileri.Olgunluk4 }}</td>
          <td>{{ TableDataVerileri.Olgunluk5 }}</td>
          <td >
              <b-button-group>
                <b-button variant="success" v-b-modal.StrIcDegerBirim @click="$emit('Icdegerid', TableDataVerileri.Id)"><i class="fas fa-plus"></i></b-button>
                <b-button variant="primary" v-b-modal.StrIcDegerTablo @click="$emit('Seviye', TableDataVerileri.Seviye), $emit('AddEdit', 'Edit'), $emit('DataUpdate', TableDataVerileri)"><i class="fa fa-pencil-alt"></i></b-button>
                <b-button variant="danger" @click="Delete('StrIcDegerTablo', TableDataVerileri.Id)"><i class="fa fa-trash-alt"></i></b-button>
              </b-button-group>
          </td>
        </tr>
        <tr> 
          <td colspan="10">
            <b-collapse class="collapse show p-3" :id="'CollapseAltTablo2' + TableDataVerileri.Id">
              <StrIcDegerBirim :Icdegerid="TableDataVerileri.Id" @Icdegerid="$emit('Icdegerid', $event)" :UpdateAltTable="UpdateAltTable"/>
            </b-collapse>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
